import React from 'react';
import { Box, Skeleton } from '@cubeyou-team/hx-react-components';
import { StyledDemographicsItem } from '../../DemographicItem/components';
import { StyledDemographicsItemsContainer } from '../../DemographicsItems/components';

const DemographicLoader = () => {
  const ItemLoader = () => (
    <Skeleton
      speed={2}
      width={340}
      height={20}
      viewBox="0 0 340 20"
      style={{ width: '100%' }}
    >
      <rect x="10" y="2" rx="4" ry="4" width="14" height="16" />
      <rect x="60" y="2" rx="4" ry="4" width="140" height="16" />
    </Skeleton>
  );
  return (
    <Box mT="large">
      <Box pB="large">
        <StyledDemographicsItemsContainer>
          <StyledDemographicsItem>
            <ItemLoader />
          </StyledDemographicsItem>
          <StyledDemographicsItem>
            <ItemLoader />
          </StyledDemographicsItem>
          <StyledDemographicsItem>
            <ItemLoader />
          </StyledDemographicsItem>
          <StyledDemographicsItem>
            <ItemLoader />
          </StyledDemographicsItem>
          <StyledDemographicsItem>
            <ItemLoader />
          </StyledDemographicsItem>
          <StyledDemographicsItem>
            <ItemLoader />
          </StyledDemographicsItem>
        </StyledDemographicsItemsContainer>
      </Box>
      <Box pB="large">
        <StyledDemographicsItemsContainer>
          <StyledDemographicsItem>
            <ItemLoader />
          </StyledDemographicsItem>
          <StyledDemographicsItem>
            <ItemLoader />
          </StyledDemographicsItem>
          <StyledDemographicsItem>
            <ItemLoader />
          </StyledDemographicsItem>
          <StyledDemographicsItem>
            <ItemLoader />
          </StyledDemographicsItem>
          <StyledDemographicsItem>
            <ItemLoader />
          </StyledDemographicsItem>
          <StyledDemographicsItem>
            <ItemLoader />
          </StyledDemographicsItem>
          <StyledDemographicsItem>
            <ItemLoader />
          </StyledDemographicsItem>
          <StyledDemographicsItem>
            <ItemLoader />
          </StyledDemographicsItem>
          <StyledDemographicsItem>
            <ItemLoader />
          </StyledDemographicsItem>
        </StyledDemographicsItemsContainer>
      </Box>
    </Box>
  );
};

export default DemographicLoader;
